module.exports = __webpack_public_path__ + "img/avatar6.333f81db.png";